<ng-container *ngIf="userInfo">
    <div class="bg-white p-6">
        <h1 class="typography-title-m m-0">
            {{'my_sales.identify_the_project_materials' | translate}}
        </h1>
        <div class="divider mt-3 mb-6"></div>
        <app-invoice-selection
            [userInfo]="userInfo"
            [initialSelectedInvoices]="initialSelectedInvoices"
            [type]="'sale'"
            [entityId]="saleId || undefined"
            [tableColumns]="tableColumns"
            (invoiceSelected)="onInvoiceSelect($event)"
        ></app-invoice-selection>
    </div>

    <!-- Navigation Buttons -->
    <div
        class="bg-white mt-6 px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-end">
        <div>
            <app-button
                [primary]="true"
                (click)="onContinue()"
                [disabled]="!canContinue()"
                [isFullWidth]="true"
                class="md:w-auto"
            >
                {{'my_sales.continue_button' | translate }}
            </app-button>
        </div>
    </div>
</ng-container>